import { createContext, useContext } from 'react';

export type ToastTone = 'success' | 'error' | 'warning' | 'info';

export interface ToastAction {
  label: string;
  onClick: () => void;
}

export interface ToastInput {
  tone?: ToastTone;
  /** Verbo no participio, combinando com o botao: "Publicar" -> "Publicado". */
  message: string;
  /** Detalhe curto — ex.: o codigo da ocorrencia num erro. */
  description?: string;
  /** Acao de desfazer, quando a operacao permitir. */
  action?: ToastAction;
  /** Duracao em ms. Padrao 5000; erro fica ate ser dispensado. */
  durationMs?: number;
}

export interface ToastItem extends ToastInput {
  id: string;
}

export interface ToastContextValue {
  show: (input: ToastInput) => string;
  success: (message: string, input?: Omit<ToastInput, 'message' | 'tone'>) => string;
  error: (message: string, input?: Omit<ToastInput, 'message' | 'tone'>) => string;
  /** Aviso: a operação foi feita, mas algo merece atenção antes da próxima. */
  warning: (message: string, input?: Omit<ToastInput, 'message' | 'tone'>) => string;
  dismiss: (id: string) => void;
}

export const ToastContext = createContext<ToastContextValue | null>(null);

/** Acesso ao sistema de avisos. Precisa estar sob `ToastProvider`. */
export function useToast(): ToastContextValue {
  const context = useContext(ToastContext);
  if (!context) {
    throw new Error('useToast precisa estar dentro de <ToastProvider>.');
  }
  return context;
}
